import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const Queue2Icon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="-1 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.334 9.08325C19.9627 9.08356 21.3239 10.2237 21.666 11.7493H25C25.4138 11.7494 25.7496 12.0855 25.75 12.4993C25.75 12.9134 25.4141 13.2491 25 13.2493H21.666C21.3242 14.7752 19.963 15.916 18.334 15.9163C16.7046 15.9163 15.3417 14.7756 15 13.2493H10.999C10.6572 14.7753 9.29614 15.9161 7.66699 15.9163C6.0376 15.9163 4.67476 14.7756 4.33301 13.2493H1C0.585786 13.2493 0.25 12.9135 0.25 12.4993C0.250352 12.0854 0.586004 11.7493 1 11.7493H4.33301C4.6751 10.2234 6.03793 9.08325 7.66699 9.08325C9.29581 9.0834 10.6569 10.2237 10.999 11.7493H15C15.3421 10.2235 16.7049 9.08325 18.334 9.08325ZM7.66699 10.5833C6.60866 10.5833 5.75035 11.441 5.75 12.4993C5.75 13.5578 6.60845 14.4163 7.66699 14.4163C8.72539 14.4161 9.58301 13.5577 9.58301 12.4993C9.58266 11.4411 8.72517 10.5834 7.66699 10.5833ZM18.334 10.5833C17.2757 10.5833 16.4173 11.441 16.417 12.4993C16.417 13.5578 17.2754 14.4163 18.334 14.4163C19.3922 14.4159 20.25 13.5576 20.25 12.4993C20.2496 11.4412 19.392 10.5836 18.334 10.5833Z"
        fill={iconColor}
      />
    </Box>
  );
};
